import {
    PbxHttpClient
} from "@/services/httpclient";

const state = {
    allStatus: []
};

const getters = {
    GET_ALL_STATUS(state) {
        return state.allStatus;
    },
};

const mutations = {
    SET_ALL_STATUS(state, payload) {
        state.allStatus = payload;
    },
};

const actions = {
    async EXTENSION_STATUS({
        commit
    }) {
        try {
            const response = await PbxHttpClient.get("/manager/extension");
            commit("SET_ALL_STATUS", response.data.data);
            return response;
        } catch (error) {
            return Promise.reject(error);
        }
    },


};

// Exportar Extensiones 
export const extension = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};